// extracted by mini-css-extract-plugin
export var active = "_64-a";
export var activeIndicator = "_64-9";
export var disabled = "_64-b";
export var fullWidth = "_64-2";
export var lg = "_64-7";
export var md = "_64-6";
export var redoButtonTabGroup = "_64-0";
export var sm = "_64-5";
export var tabButton = "_64-4";
export var tabButtonsContainer = "_64-1";
export var themeDestructive = "_64-d";
export var themeNormal = "_64-c";
export var themeSuccess = "_64-e";
export var xl = "_64-8";
export var xs = "_64-3";